import { CommonResponse, TableRequestType, TableReponseType } from '@/types';
import { httpRequest } from '@/utils/request';

export interface WorkOrderAddRequest {
  orderType: string;
  deviceId?: string;
  customerId?: string;
  description?: string;
  images?: string;
  location?: string;
  contactName?: string;
  contactPhone?: string;
  priority?: number;
}

export interface WorkOrderUpdateRequest {
  id: string;
  description?: string;
  images?: string;
  location?: string;
  contactName?: string;
  contactPhone?: string;
  priority?: number;
  remark?: string;
}

export interface WorkOrderAssignRequest {
  id: string;
  providerId: string;
}

export interface WorkOrderCompleteRequest {
  id: string;
  remark?: string;
  billingMode?: string;
}

export interface WorkOrderQueryResponse {
  id: string;
  orderNo: string;
  orderType: string;
  deviceId: string;
  deviceName: string;
  customerId: string;
  customerName: string;
  providerId: string;
  providerName: string;
  status: string;
  priority: number;
  description: string;
  images: string;
  location: string;
  contactName: string;
  contactPhone: string;
  assignedTime: number;
  completedTime: number;
  remark: string;
  created: number;
  modified: number;
}

export function getWorkOrderList<T>(
  params: TableRequestType & {
    orderType?: string;
    status?: string;
    customerId?: string;
    providerId?: string;
    deviceId?: string;
  },
) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>>({
    url: '/api/v1/work-orders',
    params,
  });
}

export function getWorkOrderById(id: string) {
  return httpRequest<any, CommonResponse<WorkOrderQueryResponse>>({
    url: `/api/v1/work-order/${id}`,
  });
}

export function addWorkOrder(data: WorkOrderAddRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/work-order',
    method: 'post',
    data,
  });
}

export function updateWorkOrder(data: WorkOrderUpdateRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/work-order',
    method: 'put',
    data,
  });
}

export function deleteWorkOrder(id: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/work-order/${id}`,
    method: 'delete',
  });
}

export function assignWorkOrder(data: WorkOrderAssignRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/work-order/assign',
    method: 'post',
    data,
  });
}

export function completeWorkOrder(data: WorkOrderCompleteRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/work-order/complete',
    method: 'post',
    data,
  });
}

export interface ProviderUserResponse {
  id: string;
  username: string;
  nickName: string;
}

export function getProviderUsers() {
  return httpRequest<any, CommonResponse<ProviderUserResponse[]>>({
    url: '/api/v1/providers',
  });
}

export function getCustomerUsers() {
  return httpRequest<any, CommonResponse<ProviderUserResponse[]>>({
    url: '/api/v1/customers',
  });
}

export interface RechargeBalanceRequest {
  customerId: string;
  amount: number;
}

export function rechargeBalance(data: RechargeBalanceRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/recharge-balance',
    method: 'post',
    data,
  });
}
